export const environment = {
    production: false,
    apiUrl : "https://dev-admin-api.fieldforce-ai.com"
  };